/**
 * Which environment this bundle was built for — declared, not inferred.
 *
 * The backend half is `backend/services/portal_env.py`, and the two must agree on
 * the four names: a bundle that thinks it is staging talking to an API that thinks
 * it is production is worse than either being wrong on its own.
 *
 * **This is fixed at build time, not at run time.** Create React App inlines every
 * `process.env.REACT_APP_*` reference into the bundle during `craco build`, so the
 * value below is a literal in the compiled output. One consequence worth stating
 * plainly, because it shapes how images are built: *a frontend image is specific
 * to one environment*. The same image cannot be promoted from staging to
 * production — promoting it would carry staging's declaration with it.
 *
 * Unrecognised resolves to `UNKNOWN`, never to a real environment, for the reason
 * the backend module gives: callers grant rights by environment, so a default
 * grants somebody's.
 */

export const LOCAL = 'local';
export const DEVELOP = 'develop';
export const STAGING = 'staging';
export const PRODUCTION = 'production';
export const UNKNOWN = 'unknown';

/** The environments that exist, least to most privileged. */
export const KNOWN = [LOCAL, DEVELOP, STAGING, PRODUCTION];

/**
 * This bundle's environment: one of `KNOWN`, or `UNKNOWN`.
 *
 * @param {string} [raw] the declared value; defaults to the build-time variable.
 * @returns {string}
 */
export function portalEnv(raw = process.env.REACT_APP_PORTAL_ENV) {
  const value = String(raw ?? '').trim().toLowerCase();
  return KNOWN.includes(value) ? value : UNKNOWN;
}

/** Whether this bundle could identify its environment at all. */
export function isKnown(raw) {
  return KNOWN.includes(portalEnv(raw));
}

/** Whether this is production. Never true for `UNKNOWN`. */
export function isProduction(raw) {
  return portalEnv(raw) === PRODUCTION;
}
